import _ from "lodash";
import React, { useEffect, useState } from "react";
import { DesktopContainer } from "../layouts";
import Select from "react-select";
import { Button, Col, Row, Input } from "reactstrap"; // Alert as ReactstrapAlert, 
import { api, dateHelpers, filterHelpers } from "../utils";
import { EmployeeTransactionEntryGrid, FilterableScreen, FilterDateTime } from "./";
import ServiceThreadSpinner from "./ServiceThreadSpinner";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";

const timeUnitTypes = [
   { value: 0, label: "Minutes" },
   { value: 1, label: "Hours" },
   { value: 2, label: "Days" },
   { value: 3, label: "Weeks" },
];
const today = new Date();
const currentDate = dateHelpers.dateTimeFormat(today, "YYYY-MM-DD");

export default function EmployeeTransactionEntry(props) {
   const [absenceReasons, setAbsenceReasons] = useState(props.absenceReasons ? props.absenceReasons : null);
   const [absenceRecords, setAbsenceRecords] = useState([]);
   const [absenceTypes, setAbsenceTypes] = useState(props.absenceTypes ? props.absenceTypes : null);
   const [comment, setComment] = useState("");
   const [displayEmployee, setDisplayEmployee] = useState(null);
   const [editAttendanceRecord, setEditAttendanceRecord] = useState(null);
   const [employeeList, setEmployeeList] = useState(props.employees ? props.employees : null);
   const [formattedEmployeeList, setFormattedEmployeeList] = useState(props.formattedEmployeeList ? props.formattedEmployeeList : null);
   const [isEdit, setIsEdit] = useState(false);
   const [isWorking, setIsWorking] = useState(false);
   const [refresh, setRefresh] = useState(false);
   const [selectedAbsenceReason, setSelectedAbsenceReason] = useState(null);
   const [selectedAbsenceType, setSelectedAbsenceType] = useState(null);
   const [selectedEmployee, setSelectedEmployee] = useState({ label: "--- Select Employee---", value: "" });
   const [selectedTimeCode, setSelectedTimeCode] = useState(null);
   const [selectedTimeUnitType, setSelectedTimeUnitType] = useState({ value: 0, label: "Minutes" });
   const [timeCodes, setTimeCodes] = useState([]);
   const [timeEntry, setTimeEntry] = useState("");
   const [filters, setFilters] = useState([
      { filterName: "startDate", value: currentDate },
      { filterName: "endDate", value: currentDate },
      { filterName: "reportStartDate", value: null },
      { filterName: "reportEndDate", value: null },
   ]);

   useEffect(() => {
      getTimeCodes();
      getEmployeeAbsenceReasons();
      if (timeCodes !== props.timeCodes) {
         setTimeCodes(props.timeCodes);
      }
      if (absenceTypes !== props.absenceTypes) {
         setAbsenceTypes(props.absenceTypes);
      }
      if (employeeList !== props.employees) {
         setEmployeeList(props.employees);
      }
      if (formattedEmployeeList !== props.formattedEmployeeList) {
         setFormattedEmployeeList(props.formattedEmployeeList);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.timeCodes, props.absenceTypes, props.employees, props.formattedEmployeeList]);

   useEffect(() => {
      if (displayEmployee) {
         getEmployeeAbsenceRecords();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [refresh]);

   function addEditEmployeeAttendanceRecord() {
      setIsWorking(true);
      api
         .post("Reference/AddEditEmployeeAttendanceRecord", createPayload())
         .then((response) => {
            if (response && response.data.success) {
               toast.success("Attendance Record successfully added or edited.");
            } else {
               toast.error("Error adding or editing Employee Attendance Record");
            }
         })
         .catch(api.catchHandler)
         .finally(() => setIsWorking(false));
      setIsEdit(false);
      setRefresh(!refresh);
      clearFields();
   }

   function clearFields() {
      setSelectedTimeCode(null);
      handleEditDate("startDate", currentDate);
      handleEditDate("editDate", currentDate);
      setTimeEntry("");
      setSelectedTimeUnitType({ value: 0, label: "Minutes" });
      setSelectedAbsenceReason(null);
      setSelectedAbsenceType(null);
      setComment("");
   }

   function createPayload() {
      let payload = {
         transactionId: editAttendanceRecord
            ? editAttendanceRecord.transactionId
            : 0,
         employeeId: displayEmployee.employid,
         notes: comment,
         startDate: filterHelpers.getValue(filters, "startDate"),
         endDate: filterHelpers.getValue(filters, "endDate"),
         unitType: selectedTimeUnitType.value,
         units: timeEntry,
         absenceType: selectedAbsenceType.value,
         absenceReason: selectedAbsenceReason.value,
         timeCode: selectedTimeCode.value,
         addedBy: editAttendanceRecord ? editAttendanceRecord.addedBy : "",
         addedDate: editAttendanceRecord
            ? editAttendanceRecord.addedDate
            : new Date(),
      };
      return payload;
   }

   function deleteAttendanceRecord(transactionId) {
      confirmAlert({
         title: "Delete Employee Attendance Record",
         message: "Are you sure you want to delete this attendance record?",
         buttons: [
            {
               label: "Ok",
               onClick: () => {
                  setIsWorking(true);
                  api
                     .fetch(
                        `Reference/DeleteEmployeeAttendanceRecord/${transactionId}`
                     )
                     .then((response) => {
                        if (response && response.data.success) {
                           toast.success(
                              "Successfully deleted Employee attendance record."
                           );
                        } else {
                           toast.error("Error deleting employee attendance response");
                        }
                     })
                     .catch(api.catchHandler)
                     .finally(() => setIsWorking(false));
               },
            },
            {
               label: "Cancel",
               onClick: () => {
                  searchFocus();
               },
            },
         ],
      });
   }

   function findEmployee() {
      if (!selectedEmployee.value) {
         toast.error("Please select an employee.");
         return;
      }

      setIsWorking(true);
      getEmployeeAbsenceRecords();
      let employee = _.find(employeeList, { employid: selectedEmployee.value });
      setDisplayEmployee(employee);
      setIsWorking(false);
   }

   function getEditAttendanceRecord(record) {
      setIsWorking(true);
      setIsEdit(true);
      setEditAttendanceRecord(record);
      setSelectedTimeCode(_.find(timeCodes, ["value", record.timeCode]));
      handleEditDate("startDate", record.startDate);
      handleEditDate("endDate", record.endDate);
      setTimeEntry(record.hoursEditFormat);
      setSelectedTimeUnitType(
         _.find(timeUnitTypes, ["value", record.timeUnitEntryType])
      );
      setSelectedAbsenceReason(
         _.find(absenceReasons, ["value", record.absenceReason])
      );
      setSelectedAbsenceType(_.find(absenceTypes, ["value", record.absenceType]));
      setComment(record.notes);
      setIsWorking(false);
   }

   function getEmployeeAbsenceReasons() {
      api
         .fetch("Reference/GetEmployeeAbsenceReasons")
         .then((response) => {
            if (response && response.data.success) {
               let list = _.map(response.data.message, (x) => {
                  return {
                     label: x.attendanceReason,
                     value: x.attendanceReason,
                  };
               });
               setAbsenceReasons(_.sortBy(list, ["label"]));
            } else {
               toast.error("Failed to fetch Employee Absence Reasons");
            }
         })
         .catch(api.catchHandler);
   }

   function getEmployeeAbsenceRecords() {
      setIsWorking(true);
      api
         .post("Reference/GetEmployeeAttendance", {
            EmployeeId: selectedEmployee.value,
         })
         .then((response) => {
            if (response && response.data && response.data.success) {
               setAbsenceRecords(response.data.message);
            } else {
               toast.error("Error getting employee attendance.");
            }
         })
         .catch(api.catchHandler)
         .finally(() => setIsWorking(false));
   }

   function getTimeCodes() {
      api
         .fetch("Reference/GetTimeCodes")
         .then((response) => {
            if (response && response.data.success) {
               let list = _.map(response.data.message, (x) => {
                  return {
                     label: x.description,
                     value: x.timeCode,
                  };
               });
               let sortedList = _.sortBy(list, ["label"]);
               setTimeCodes(sortedList);
            } else {
               toast.error("Failed to fetch Time Codes");
            }
         })
         .catch(api.catchHandler);
   }

   function handleEditDate(filter, dateValue) {
      let filterCopy = [...filters];
      for (let i = 0; i < filterCopy.length; i++) {
         _.forEach(filterCopy[i], function (value, key) {
            if (value === filter) {
               filterCopy[i].value = dateHelpers.dateTimeFormat(
                  dateValue,
                  "YYYY-MM-DD"
               );
            }
         });
      }
      setFilters(filterCopy);
   }

   function onFilterChange(changedFilter) {
      const filterChanges = filterHelpers.getFilters(filters, changedFilter);
      setFilters(filterChanges);
   }

   async function searchFocus() {
      const srch = document.querySelector(`input[name=searchInput]`);
      if (srch !== null) {
         await srch.focus();
      }
   }

   return (
      <>
         <DesktopContainer screenName="Employee Transaction Entry">
            <FilterableScreen
               filters={
                  <div className="filter-header stick-top mb-3">
                     <Row className="mt-3">
                        <Col xs="3" style={{ textAlign: "right", marginRight: "5px", color: "white", }} >
                           <h5>Select Employee:</h5>
                        </Col>
                        <Col xs="6">
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={formattedEmployeeList}
                              onChange={(e) => setSelectedEmployee(e)}
                              value={selectedEmployee}
                              name="searchInput"
                           />
                        </Col>
                        <Col>
                           <Button
                              className="shredButton"
                              onClick={() => findEmployee()}
                              disabled={isWorking}
                           >
                              VIEW
                           </Button>
                        </Col>
                     </Row>
                  </div>
               }
            >
               <ServiceThreadSpinner on={isWorking}>
                  {displayEmployee ? (
                     <>
                        <Row className="mt-3 d-flex justify-content-center mb-5 filter-header mx-1">
                           <Col xs="6">
                              <Row className="mt-3 d-flex align-items-center">
                                 <Col xs="3">
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       Name:
                                    </p>
                                 </Col>
                                 <Col>
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       {displayEmployee?.employeeName}
                                    </p>
                                 </Col>
                              </Row>
                              <Row className="mt-3 d-flex align-items-center">
                                 <Col xs="3">
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       Department:
                                    </p>
                                 </Col>
                                 <Col>
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       {displayEmployee?.deparmentdescription}
                                    </p>
                                 </Col>
                              </Row>
                              <Row className="mt-3 d-flex align-items-center">
                                 <Col xs="3">
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       Job:
                                    </p>
                                 </Col>
                                 <Col>
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       {displayEmployee?.jobtitledescription}
                                    </p>
                                 </Col>
                              </Row>
                              <Row className="mt-3 d-flex align-items-center">
                                 <Col xs="3">
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       Supervisor:
                                    </p>
                                 </Col>
                                 <Col>
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       {displayEmployee?.supervisorName}
                                    </p>
                                 </Col>
                              </Row>
                              <Row className="mt-3 d-flex align-items-center">
                                 <Col xs="3">
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       Time Code:
                                    </p>
                                 </Col>
                                 <Col>
                                    <Select
                                       classNamePrefix="serviceThreadSelect"
                                       options={timeCodes}
                                       value={selectedTimeCode}
                                       onChange={(e) => setSelectedTimeCode(e)}
                                    />
                                 </Col>
                              </Row>
                              <Row className="mt-3 d-flex align-items-center">
                                 <Col xs="3">
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       Start Date:
                                    </p>
                                 </Col>
                                 <Col>
                                    <FilterDateTime
                                       filterName="startDate"
                                       value={filterHelpers.getValue(filters, "startDate")}
                                       onChangeCallback={onFilterChange}
                                    />
                                 </Col>
                              </Row>
                              <Row className="mt-3 d-flex align-items-center">
                                 <Col xs="3">
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       End Date:
                                    </p>
                                 </Col>
                                 <Col>
                                    <FilterDateTime
                                       filterName="endDate"
                                       value={filterHelpers.getValue(filters, "endDate")}
                                       onChangeCallback={onFilterChange}
                                    />
                                 </Col>
                              </Row>
                              <Row className="mt-3 d-flex align-items-center">
                                 <Col xs="3">
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       Time:
                                    </p>
                                 </Col>
                                 <Col>
                                    <Input
                                       classNamePrefix="serviceThreadSelect"
                                       value={timeEntry}
                                       onChange={(e) => setTimeEntry(e.target.value)}
                                    />
                                 </Col>
                              </Row>
                              <Row className="mt-3 d-flex align-items-center">
                                 <Col xs="3">
                                    <p></p>
                                 </Col>
                                 <Col>
                                    <Select
                                       classNamePrefix="serviceThreadSelect"
                                       options={timeUnitTypes}
                                       onChange={(e) => setSelectedTimeUnitType(e)}
                                       value={selectedTimeUnitType}
                                    />
                                 </Col>
                              </Row>
                              <Row className="mt-3 d-flex align-items-center">
                                 <Col xs="3">
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       Reason:
                                    </p>
                                 </Col>
                                 <Col>
                                    <Select
                                       classNamePrefix="serviceThreadSelect"
                                       options={absenceReasons}
                                       onChange={(e) => setSelectedAbsenceReason(e)}
                                       value={selectedAbsenceReason}
                                    />
                                 </Col>
                              </Row>
                              <Row className="mt-3 d-flex align-items-center">
                                 <Col xs="3">
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       Type:
                                    </p>
                                 </Col>
                                 <Col>
                                    <Select
                                       classNamePrefix="serviceThreadSelect"
                                       options={absenceTypes}
                                       onChange={(e) => setSelectedAbsenceType(e)}
                                       value={selectedAbsenceType}
                                    />
                                 </Col>
                              </Row>
                              <Row className="mt-3 d-flex align-items-center">
                                 <Col xs="3">
                                    <p style={{ color: "white", fontSize: "1.25rem" }}>
                                       Comments:
                                    </p>
                                 </Col>
                                 <Col>
                                    <Input
                                       className="serviceThreadTextArea"
                                       type="textarea"
                                       value={comment}
                                       maxLength={400}
                                       onChange={(e) => setComment(e.target.value)}
                                    />
                                 </Col>
                              </Row>
                              <Row className="mt-3 d-flex align-items-center">
                                 <Col xs="4">
                                    {isEdit ? (
                                       <Button className="shredButton" onClick={() => addEditEmployeeAttendanceRecord()} >
                                          EDIT ATTENDANCE RECORD
                                       </Button>
                                    ) : (
                                       <Button className="shredButton" onClick={() => addEditEmployeeAttendanceRecord()} >
                                          ADD ATTENDANCE RECORD
                                       </Button>
                                    )}
                                 </Col>
                                 <Col></Col>
                              </Row>
                           </Col>
                        </Row>
                        <Row className="mt-3 d-flex justify-content-center mb-5 mx-1">
                           <EmployeeTransactionEntryGrid
                              data={absenceRecords}
                              callback={getEditAttendanceRecord}
                              deleteCallback={deleteAttendanceRecord}
                           />
                        </Row>
                     </>
                  ) : null}
               </ServiceThreadSpinner>
            </FilterableScreen>
         </DesktopContainer>
      </>
   );
}
